import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { StatePanel } from "@anyseal/ui";
import { AdminShell } from "./AdminShell";
import { useAuth } from "./auth";
import { useI18n } from "./i18n";
import { LoginPage } from "./pages/LoginPage";
import { OverviewPage } from "./pages/OverviewPage";
import { ChannelsPage } from "./pages/ChannelsPage";
import { CatalogPage } from "./pages/CatalogPage";
import { RoutingPage } from "./pages/RoutingPage";
import { UsersPage } from "./pages/UsersPage";
import { AdminBillingPage } from "./pages/AdminBillingPage";
import { DiagnosticsPage } from "./pages/DiagnosticsPage";
import { AuditPage } from "./pages/AuditPage";
import { OperationsPage } from "./pages/OperationsPage";
import { GrowthPage } from "./pages/GrowthPage";
import { DeploymentsPage } from "./pages/DeploymentsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { RiskPage } from "./pages/RiskPage";
import { OAuthCompletePage, OAuthErrorPage } from "./pages/OAuthPages";

function Guard() {
  const { status } = useAuth();
  const { locale } = useI18n();
  const location = useLocation();
  if (status === "initializing") return <main className="admin-standalone"><StatePanel kind="loading" title={locale === "zh-CN" ? "正在验证管理会话" : "Verifying administrator session"} /></main>;
  if (status === "anonymous") return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <AdminShell />;
}

function NotFoundPage() {
  const { locale } = useI18n();
  return <StatePanel kind="empty" title="404" description={locale === "zh-CN" ? "这个管理页面不存在。" : "This admin page does not exist."} />;
}

export function App() { return <Routes><Route path="/login" element={<LoginPage />} /><Route path="/auth/oauth/complete" element={<OAuthCompletePage />} /><Route path="/auth/oauth/error" element={<OAuthErrorPage />} /><Route element={<Guard />}><Route index element={<OverviewPage />} /><Route path="channels" element={<ChannelsPage />} /><Route path="catalog" element={<CatalogPage />} /><Route path="routing" element={<RoutingPage />} /><Route path="users" element={<UsersPage />} /><Route path="billing" element={<AdminBillingPage />} /><Route path="risk" element={<RiskPage />} /><Route path="diagnostics" element={<DiagnosticsPage />} /><Route path="audit" element={<AuditPage />} /><Route path="operations" element={<OperationsPage />} /><Route path="growth" element={<GrowthPage />} /><Route path="deployments" element={<DeploymentsPage />} /><Route path="settings" element={<SettingsPage />} /><Route path="*" element={<NotFoundPage />} /></Route></Routes>; }
